import { useEffect, useMemo, useState } from "react";
import PriorVisitHeader from "./proirvisitHeader";
import { PriorCardsGrid, PriorCardsList } from "./priorcards";
import { SummaryCardGrid, SummaryCardsList } from "./summarycard";
import { AudioCardGrid, Audiocards } from "./audiocards";
import dayjs from 'dayjs';

import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../../../../api/api";
import RenderBlinkscribeRecords from "./blinkscribeRecords/blinkscribeRecords";
import { set } from "date-fns";
import { is } from "date-fns/locale";
import DropdownPill from "../Document/DropdownPill";
import ProcedureDocument from "../Document/ProcedureDocument";
import PaymentHistory from "./PaymentHistory";
const formatDate = (dateString) => {
  return dayjs(dateString).format('YYYY-MM-DD');
};

const PriorVisit = ({internavtab ,searchdate ,dataId}) => {
  const [view, setView] = useState(1);
  const [selectedTab, setSelectedTab] = useState(internavtab===false?0:internavtab);
  const [searchDate, setSearchDate] = useState(formatDate(searchdate));
  const [pData, setPData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documentHtml, setDocumentHtml] = useState("");
  const practiseid = window.getPracticeId();
const [documentloading,setdocumentLoading]=useState(false)
const [isDocumentVisible, setDocumentVisible] = useState(false);
const [progessnotesdata,setProgressnotesData]=useState([])
const [progressnotesmodal,setProgressnotesModal]=useState(false)
const [selectedprocedure,setselectedProcedure]=useState({})
  const [selectedYear, setSelectedYear] = useState("all");
const [paymentHistory, setPaymentHistory] = useState([]);
const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  // ✅ Manage selected range
const [selectedDateRange, setSelectedDateRange] = useState({
  startDate: dayjs().subtract(1, "month").toDate(), // 1 month ago
  endDate: dayjs().toDate(),                         // today
  key: "selection",
});
   // Fetch procedure data based on the selected search date
   const patientId=dataId.patientid

   const fetchPriorVisitData = async () => {
    setIsLoading(true);
    try {
      const payload = {
       departmentid: 1
      };
      const response = await api.post(`/v1/${practiseid}/patient/${patientId}/encounter`, payload);

      if (response.status === 200 && response.data.encounters) {
        setPData(response.data.encounters); // Set encounters correctly
      } else {
        setPData([]); // Reset to empty array if no encounters
      }
    } catch (error) {
      console.error("Error fetching procedure data:", error.response ? error.response.data : error);
    } finally {
      setIsLoading(false);
    }
  };

  // console.log('Prior Visit',pData)

  useEffect(() => {
        fetchPriorVisitData();
  }, [patientId]);
useEffect(() => {
  if (selectedTab === 1) {
    setSelectedDateRange({
      startDate: null,
      endDate: null,
      key: "selection",
    });
  }
}, [selectedTab]);
  const fetchDocument = async (encounterId) => {
  setdocumentLoading(true)
    console.log('encounterID',encounterId)
    try {
    const  payload={
        encounter_id:encounterId
      }

      const response = await api.post(`/v1/${practiseid}/encounter/specific-summary`,  payload );
  
      if (response.status === 200) {
         setDocumentHtml(response.data.summaryhtml); 
         setDocumentVisible(true);
      }
    } catch (error) {
      console.error("Error fetching document:", error.response ? error.response.data : error);
    }finally{
      setdocumentLoading(false)
    }
  };
     const fetchProgress = async () => {
    setIsLoading(true);
    try {
      const payload = {
        category: "ProgressNotes",
        department_id: 1,
      };
      const response = await api.post(
        `/v1/${practiseid}/patient/${patientId}/procedures/get`,
        payload
      );

      if (response.status === 200) {
    setProgressnotesData(response?.data||[])
      }else{
        setProgressnotesData([])
      }
    } catch (error) {
      console.error(
        "Error fetching procedure data:",
        error.response ? error.response.data : error
      );
    } finally {
      setIsLoading(false);
    }
  };
   const fetchPayments = async () => {
      try {
        setIsPaymentLoading(true);
        const response = await api.get(
          `/v1/${practiseid}/pcard/${dataId?.patientid}/getPaymentDetails`
        );
        if (response.status === 200) {
          setPaymentHistory(response.data || []);
        } else {
          setPaymentHistory([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsPaymentLoading(false);
      }
    };
useEffect(()=>{
  if(selectedTab==2){
    fetchProgress()
  }else if(selectedTab==3){
    fetchPayments()
  }
},[selectedTab])
 const yearOptions = useMemo(() => {
  const docs = progessnotesdata?.encounterdocuments || [];
  if (!Array.isArray(docs) || docs.length === 0)
    return [{ label: "All", value: "all" }];

  const years = docs
    .map((doc) => {
      // handle multiple possible date fields
      const dateValue =
        doc?.date ||
        doc?.created_at ||
        doc?.updated_at ||
        doc?.encounter_date ||
        doc?.createddate ||
        doc?.createddatetime ||
        doc?.lastmodifieddatetime;

      if (!dateValue) return null;
      const parsed = dayjs(dateValue);
      return parsed.isValid() ? parsed.year().toString() : null;
    })
    .filter(Boolean);

  const uniqueYears = Array.from(new Set(years)).sort((a, b) => b - a);

  return [
    { label: "All", value: "all" },
    ...uniqueYears.map((y) => ({ label: y, value: y })),
  ];
}, [progessnotesdata]);

const filteredDocs = useMemo(() => {
  if (!Array.isArray(progessnotesdata?.encounterdocuments)) return [];

  const docs = progessnotesdata.encounterdocuments;

  if (selectedYear === "all") return docs;

  return docs.filter((x) => {
    const dateValue =
      x?.date ||
      x?.created_at ||
      x?.updated_at ||
      x?.encounter_date ||
      x?.createddate ||
      x?.createddatetime ||
      x?.lastmodifieddatetime;

    if (!dateValue) return false;

    const parsed = dayjs(dateValue);
    if (!parsed.isValid()) return false;

    return parsed.year().toString() === selectedYear;
  });
}, [progessnotesdata, selectedYear]);
useEffect(() => {
    if (isDocumentVisible) {
      const sections = document.querySelectorAll(".section:not(.always-expanded)");
      sections.forEach((section) => {
        const header = section.querySelector(".section-header");
        if (!header.dataset.initialized) {
          header.addEventListener("click", () => {
            const content = section.querySelector(".section-content");
            const toggle = section.querySelector(".section-toggle");
            const isExpanded = header.classList.contains("expanded");

            if (isExpanded) {
              header.classList.remove("expanded");
              content.classList.remove("expanded");
              toggle.classList.remove("expanded");
            } else {
              header.classList.add("expanded");
              content.classList.add("expanded");
              toggle.classList.add("expanded");
            }
          });
          header.dataset.initialized = "true";
        }
      });
    }

    // Cleanup listeners when overlay closes
    return () => {
      const sections = document.querySelectorAll(".section:not(.always-expanded)");
      sections.forEach((section) => {
        const header = section.querySelector(".section-header");
        if (header.dataset.initialized) {
          header.replaceWith(header.cloneNode(true));
        }
      });
    };
  }, [isDocumentVisible, documentHtml]);
  const renderOverlay = () => {
    if (!isDocumentVisible) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div
          className="bg-white relative w-[80%] overflow-y-auto h-[95vh]"
          style={{ scrollbarWidth: 'none' }}
        >
          <div className="sticky z-10 pr-2 bg-white top-0 w-full flex justify-end">
            <button onClick={() => setDocumentVisible(false)} className="mt-2 rounded">
              <CloseIcon style={{ width: "30px" }} />
            </button>
          </div>
          <div className="p-4">
            <div dangerouslySetInnerHTML={{ __html: documentHtml }} />
          </div>
        </div>
      </div>
    );
  };
  

  const tabs = [
    { label: "Summary" },
    { label: "Audio" },
    { label: "Progress Notes" },
    { label: "Special Tab" } 
  ];
  const Handletoggle=(value)=>{
    setView(value)
  }
  // Group by year
const groupedByYear = useMemo(() => {
  if (!filteredDocs || filteredDocs.length === 0) return {};
  return filteredDocs.reduce((acc, doc) => {
    const dateValue =
      doc?.date ||
      doc?.created_at ||
      doc?.updated_at ||
      doc?.encounter_date ||
      doc?.createddate ||
      doc?.createddatetime ||
      doc?.lastmodifieddatetime;
    const year = dayjs(dateValue).isValid()
      ? dayjs(dateValue).year().toString()
      : "Unknown";
    if (!acc[year]) acc[year] = [];
    acc[year].push(doc);
    return acc;
  }, {});
}, [filteredDocs]);

// Sort years descending
const sortedYears = Object.keys(groupedByYear).sort((a, b) => b - a);

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
      
        return (
          <div className="flex flex-col gap-4 overflow-auto max-h-screen p-4">
               <Backdrop
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
              }}
              open={documentloading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          {!view ? (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 h-[450px] pt-5">
               {isLoading ? ( // Check if loading
                 <div className="w-[100%] flex justify-end items-center">
                 <CircularProgress />
                 </div>
                ) : pData.length > 0 ? (
                  pData.map((encounter) => (
                    <SummaryCardGrid
                      key={encounter.encounterid}
                      encounter={encounter}
                      onViewDocument={fetchDocument}
                    />
                  ))
                ) : (
                  <p>No encounters found.</p>
                )}
            </div>
          ) : (
            <div className="flex flex-col gap-4 h-[430px] ">
               {isLoading ? ( // Check if loading
                  <p>Loading...</p> // Or replace with a spinner
                ) : pData.length > 0 ? (
                  pData.map((encounter) => (
                    <SummaryCardsList
                      key={encounter.encounterid}
                      encounter={encounter}
                      onViewDocument={fetchDocument}
                    />
                  ))
                ) : (
                  <p>No encounters found.</p>
                )}
            </div>
          )}
        </div>
        );


      case 1:
      
        return (
          <>
             <div className="flex flex-col gap-4 h-[430px] ">
                 <RenderBlinkscribeRecords view={view} data={dataId}     setSelectedDateRange={setSelectedDateRange}
        selectedDateRange={selectedDateRange}    searchDate={searchDate} internavtab={selectedTab}/>
              </div>
         
          </>
        
        );
      case 2:
    
        return (
         <div className="flex flex-col h-screen">
  {/* Fixed Dropdown */}
  <div className="flex justify-start mb-2 px-4 pt-4 flex-shrink-0  z-10">
    <DropdownPill
      options={yearOptions}
      value={selectedYear}
      onChange={setSelectedYear}
      placeholder="Select Year"
    />
  </div>

  {/* Scrollable Content */}
  <div className="flex-1 overflow-auto px-4 pb-4">
    {view ? (
      <div className="flex flex-col gap-4">
        {filteredDocs.length > 0 ? (
          filteredDocs
            .slice()
            .sort((a, b) => {
              // Sort by most recent date (descending)
              const getDate = (d) =>
                dayjs(
                  d?.date ||
                    d?.created_at ||
                    d?.updated_at ||
                    d?.encounter_date ||
                    d?.createddate ||
                    d?.createddatetime ||
                    d?.lastmodifieddatetime
                );
              return getDate(b).valueOf() - getDate(a).valueOf();
            })
            .map((x, i) => <PriorCardsList key={i} setIsProcedureDocumentOpen={setProgressnotesModal} setselectedProcedure={setselectedProcedure} x={x} />)
        ) : !isLoading ? (
          <div className="col-span-2 text-center text-gray-500 py-6">
            No documents found
          </div>
        ) : null}
      </div>
    ) : (
   <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
  {sortedYears.length > 0 ? (
    sortedYears.map((year) => (
      <PriorCardsGrid key={year} year={year} setselectedProcedure={setselectedProcedure} setIsProcedureDocumentOpen={setProgressnotesModal}  docs={groupedByYear[year]} />
    ))
  ) : (
    <div className="col-span-2 text-center text-gray-500 py-6">
      No documents found
    </div>
  )}
</div>
    )}
  </div>
</div>

        );
      case 3:
        return (
          <div className="flex flex-col h-screen overflow-auto">
            <PaymentHistory payments={paymentHistory} isLoading={isPaymentLoading} />
          </div>
        );
      default:
        return null;
    }
  };

 

  return (
    <div className="flex flex-col justify-start h-full">
      <PriorVisitHeader 
        viewStatus={view} 
        handleView={Handletoggle} 
        tabs={tabs} 
        selectedTab={selectedTab} 
        onSelectTab={setSelectedTab} 
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        setSelectedDateRange={setSelectedDateRange}
        selectedDateRange={selectedDateRange}
      />
      {renderContent()}
      <ProcedureDocument
                  subview={2}
                  isProcedureDocumentOpen={progressnotesmodal}
                  setIsProcedureDocumentOpen={setProgressnotesModal}
                  procedure={selectedprocedure}
                />
     { renderOverlay()}
    </div>
  );
};

export default PriorVisit;
